// Due to Turbo and its body tag replacing, Selectize.$testInput value needs to be reset in order to make
// selectize.js add a span at the end of the body to correctly measure text width: https://github.com/selectize/selectize.js/blob/master/dist/js/selectize.js#L379
export function resetSelectizeToCorrectlyMeasureTextWidth() {
    (window as any).Selectize.$testInput = undefined;
}

// todo: selectize.js has newly a bootstrap 4 support - https://github.com/selectize/selectize.js/pull/1552 
// which fixed https://github.com/selectize/selectize.js/issues/851 - text clipping issue. According to the commit changes,
// the new version will be 0.13.0 - see https://github.com/selectize/selectize.js/pull/1552/commits/7472980105edad9924c21745fa789c00c25fd771
// if this works, remove custom site.css code for selectize remove plugin

// By default, selectize uses some random score function to order the search results when typing and searching.
// By using this score function it preserves the default order of options when typing and searching.
// Taken from https://github.com/selectize/selectize.js/issues/196#issuecomment-69476446; more discussions around this: https://github.com/selectize/selectize.js/issues/218
export function getScoreFunctionPreservingOrderInSearch(search: Selectize.ISearch): (item: any) => number {
    // @ts-ignore
    var score = this.getScoreFunction(search);
    return function (item) : number {
        return score(item) ? 1 : 0;
    };
}

export function selectize(jquery: JQuery, options?: Selectize.IOptions<any, any>): JQuery {
    resetSelectizeToCorrectlyMeasureTextWidth();
    return jquery.selectize(options);
}